import { ConnectButton } from "@rainbow-me/rainbowkit";



export const ConnectWalletBtn = () => {
  return (
    <ConnectButton label="Connect" />
  );
};
